import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "score-block" }
const _hoisted_4 = { class: "score" }
const _hoisted_5 = { class: "stars" }
const _hoisted_6 = { class: "count" }
const _hoisted_7 = { class: "bar-label" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "review-title" }
const _hoisted_10 = { class: "review-meta" }
const _hoisted_11 = { class: "review-date" }
const _hoisted_12 = { class: "review-body" }

import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { reviewFieldKey } from '../i18n-keys';


export default /*@__PURE__*/_defineComponent({
  __name: 'RatingsReviews',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, {
      class: "section-head",
      onClick: () => {}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "22" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('donwload.ratingAndReview')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "16",
              color: "#9ca3af"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { class: "summary" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(appData).ratings.score.toFixed(1)), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createVNode(_component_van_icon, {
                    key: i,
                    name: "star",
                    size: "12",
                    color: i <= Math.round(_unref(appData).ratings.score) ? '#111827' : '#d1d5db'
                  }, null, 8, ["color"])
                }), 64))
              ]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('donwload.review')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "16" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(appData).ratings.distribution].reverse(), (d) => {
              return (_openBlock(), _createElementBlock("div", {
                key: d.stars,
                class: "bar-row"
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(d.stars), 1),
                _createVNode(_component_van_icon, {
                  name: "star",
                  size: "10",
                  color: "#9ca3af"
                }),
                _createVNode(_component_van_progress, {
                  percentage: d.percentage,
                  "show-pivot": false,
                  color: "#9ca3af",
                  "stroke-width": "6"
                }, null, 8, ["percentage"])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(t)('appStore.ratingsMostHelpful')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).reviews, (review) => {
      return (_openBlock(), _createElementBlock("article", {
        key: review.id,
        class: "review"
      }, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(t)(_unref(reviewFieldKey)(review.i18nKey, 'title'))), 1),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createVNode(_component_van_icon, {
              key: i,
              name: "star",
              size: "12",
              color: i <= review.rating ? '#111827' : '#d1d5db'
            }, null, 8, ["color"])
          }), 64)),
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString(_unref(t)(_unref(reviewFieldKey)(review.i18nKey, 'date'))) + " · ", 1),
            _createElementVNode("em", null, _toDisplayString(_unref(t)(_unref(reviewFieldKey)(review.i18nKey, 'author'))), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)(review.comment)), 1)
      ]))
    }), 128)),
    _createVNode(_component_van_button, {
      block: "",
      round: "",
      class: "see-all"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('appStore.ratingsSeeAll')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})